export const generalKey = 'product_ps_delta_delta_3_u_p';
export const whiteLocaleList = ['jp']; //白名单
export const productPageUrl = 'delta-3-ultra-plus-portable-power-station';
export const tabsValues = ['Product', 'Specs', 'Support', 'Bundles'];
export const productPageTheme = 'white'; //主题色

export const generalKeys = [
    {
        key: 'product_ps_delta_delta_3_u_p',
    },
    // {
    //     key: 'product_ps_delta_delta_3_u',
    // },
];
